import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { RequestCategory, Request } from '../../../__generated__/pgeplus-types';
import { PageTextContentType } from '../../../hooks/useContentMgmt';
import colors from '../../../themes/main-colors';
import { formatDate } from '../../../util/format';
import { useIsMobile } from '../../../util/style-utils';
import { WelcomeBackAccordion } from './common/Accordion';
import WelcomeBackConsultationRequest from './WelcomeBackConsultationRequest';

export function InactiveConsultationRequest({
  consultationRequest,
  activeStep,
  content,
}: {
  consultationRequest: Request;
  activeStep: number;
  content: PageTextContentType;
}) {
  const isMobile = useIsMobile();

  const AppMetadata = (
    <Box
      css={{
        display: 'flex',
        padding: '12px',
        justifyContent: 'space-between',
        backgroundColor: colors.navBarBackground,
      }}
    >
      <Box
        gridGap={2}
        display={'flex'}
        flexDirection={isMobile ? 'column' : 'row'}
      >
        <Typography component="span">{content.get('REQUEST_NO')}</Typography>{' '}
        <Typography component="span" style={{ fontWeight: 700 }}>
          {consultationRequest?.requestNo}
        </Typography>
      </Box>
      <Box
        display={'flex'}
        flexDirection={isMobile ? 'column' : 'row'}
        alignItems={'flex-end'}
      >
        <Typography component="span">
          {content.get('REQUEST_SUBMISSION_DATE')}
        </Typography>{' '}
        <Typography component="span" style={{ fontWeight: 700 }}>
          {formatDate(new Date(consultationRequest?.createdAt))}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <WelcomeBackAccordion
      title={
        consultationRequest?.category === RequestCategory.HvacConsultation
          ? content.get('WELCOME_BACK_HVAC_CONSULTATION_HEADER')!
          : content.get('WELCOME_BACK_EV_CONSULTATION_HEADER')!
      }
      category={content.get('CANCELLED') || ''}
      secondaryBar={AppMetadata}
      cardContent={
        <WelcomeBackConsultationRequest
          application={consultationRequest}
          activeStep={activeStep}
          content={content}
        />
      }
    />
  );
}
